import { GridColumns } from '@mui/x-data-grid-pro'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useGetRelatedTasks } from 'src/api/task-resource'
import { DynamicTextTypography } from 'src/components/DynamicTextTypography'
import { GenericDialogLayout } from 'src/components/GenericDialogLayout'
import GenericTable from 'src/components/table/GenericTable'
import { ShowDialogProps } from 'src/show-dialog'
import { getFormattedDate } from 'src/utils'

interface RelatedTasksDialogProps extends ShowDialogProps {
  customerId: EntityId
  taskId: EntityId
}

const RelatedTasksDialog: React.FC<RelatedTasksDialogProps> = ({ pop, customerId, taskId }) => {
  const { data: relatedTasks } = useGetRelatedTasks(customerId as number, taskId as number)
  const { t } = useTranslation('common')

  const columns: GridColumns = useMemo(
    () => [
      {
        field: 'tasks.title',
        flex: 1,
        headerName: t('title'),
        cellClassName: 'font-weight-semi-bold',
        renderCell: row => <DynamicTextTypography text={row.row.tasks?.title} maxLength={18} />,
      },
      {
        field: 'tasks.locality.name',
        headerName: t('locality'),
        flex: 1,
        cellClassName: 'font-weight-semi-bold',
        renderCell: row => row.row.tasks?.locality?.name,
      },
      {
        field: 'tasks.description',
        flex: 1,
        headerName: t('description'),
        renderCell: row => <DynamicTextTypography text={row.row.tasks?.description} maxLength={18} />,
      },
      {
        field: 'startDate',
        flex: 1,
        headerName: t('startDate'),
        renderCell: params => getFormattedDate(params?.row?.startDate),
      },
      {
        field: 'endDate',
        flex: 1,
        headerName: t('endDate'),
        renderCell: params => getFormattedDate(params?.row?.endDate),
      },
    ],
    [t],
  )

  return (
    <GenericDialogLayout title={t('workOrders')} pop={pop}>
      <GenericTable
        id={'resource-related-tasks'}
        data={relatedTasks?.items || []}
        columns={columns}
        autoHeight={false}
        height={'300px'}
      />
    </GenericDialogLayout>
  )
}

export default RelatedTasksDialog
